import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface CustomerSettingsFormValues {
  euft: string;
  euft_name: string;
  client_key: string;
  client_secret: string;
  api_url: string;
}

export const customerSettingsDefaultValues: CustomerSettingsFormValues = {
  euft: '',
  euft_name: '',
  client_key: '',
  client_secret: '',
  api_url: ''
};

export const customerSettingsSchema = yup.object({
  euft: yup.string(),
  euft_name: yup.string(),
  client_key: yup
    .string()
    .required('Client Key is required')
    .min(3, 'Must be 3-64 characters and contain only letters, numbers, and hyphens.')
    .max(64, 'Must be 3-64 characters and contain only letters, numbers, and hyphens.')
    .matches(/^[a-zA-Z0-9-]+$/, 'Must be 3-64 characters and contain only letters, numbers, and hyphens.'),
  client_secret: yup
    .string()
    .required('Secret Key is required')
    .min(8, 'Must be between 8-128 characters.')
    .max(128, 'Must be between 8-128 characters.'),
  api_url: yup.string()
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useCustomerSettingsForm(initialValues?: any) {
  return useForm({
    values: initialValues || [], // fallback to empty array while loading
    mode: 'onSubmit',
    resolver: yupResolver(customerSettingsSchema),
    defaultValues: { ...customerSettingsDefaultValues, ...initialValues }
  });
}
